import React from 'react';
import { LuCircleAlert, LuTriangleAlert, LuInfo, LuCircleCheck, LuSparkles } from 'react-icons/lu';
import SectionCard, { SectionEmpty } from './SectionCard';

const SEVERITY = {
  critical: { icon: LuCircleAlert, tone: 'danger' },
  warning: { icon: LuTriangleAlert, tone: 'warning' },
  info: { icon: LuInfo, tone: 'info' },
  positive: { icon: LuCircleCheck, tone: 'success' },
};

export default function InsightsPanel({ summary, loading, error, onRetry, navigateTo, onOpenFailures }) {
  const insights = summary?.insights || [];

  const act = (target) => {
    if (!target) return;
    const [area, arg] = target.split(':');
    if (area === 'failures') onOpenFailures(arg || 'all');
    else if (area === 'test_cases') navigateTo(arg === 'automated' ? 'test-cases?type=automated' : 'test-cases');
    else navigateTo(area);
  };

  return (
    <SectionCard
      id="pqd-insights"
      title="Insights"
      subtitle="Rule-based observations computed from the metrics above."
      loading={loading}
      error={error}
      onRetry={onRetry}
      actions={
        <button type="button" className="rt2-link pqd-ai-link" onClick={() => navigateTo('intelligence')}>
          <LuSparkles size={13} aria-hidden="true" /> AI analysis
        </button>
      }
    >
      {insights.length === 0 ? (
        <SectionEmpty title="Nothing stands out">No regressions, new failures, flaky tests or coverage gaps were detected.</SectionEmpty>
      ) : (
        <ul className="pqd-insights">
          {insights.map((item) => {
            const sev = SEVERITY[item.severity] || SEVERITY.info;
            const Icon = sev.icon;
            return (
              <li key={item.id} className={`pqd-insight pqd-insight--${sev.tone}`}>
                <Icon size={16} aria-hidden="true" className="pqd-insight__icon" />
                <div className="pqd-insight__body">
                  <strong>{item.title}</strong>
                  {item.detail && <p>{item.detail}</p>}
                </div>
                {item.action && (
                  <button type="button" className="rt-btn rt-btn--tertiary rt-btn--sm" onClick={() => act(item.action.target)}>
                    {item.action.label}
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </SectionCard>
  );
}
